import React, { FC } from "react";
import FlexLine from "../../../../../../components/elements/flexLine/FlexLine";
import st from './WorkItemTitle.module.scss';
import { Tooltip } from "@infobis/ui-styles-utils";
import cn from 'classnames';

type WorkItemTitleProps = {
    displayName: string
    color?: string
    onClick?: () => void
    maxLines?: number
}

const WorkItemTitle: FC<WorkItemTitleProps> = (props) => {
    const {
        displayName,
        color,
        onClick,
        maxLines = 2
    } = props;

    return (
        <FlexLine
            style={{ cursor: onClick ? 'pointer' : 'default' }}
            className={cn(st['title'])}
            onClick={onClick}
        >
            {color && <span className={st.title__marker} style={{backgroundColor: color}}/>}
            <Tooltip.Flex
                maxLines={maxLines}
                tooltipProps={{ bodyClassName: st['title-tooltip__text'] }}
                text={<span className={st['title-tooltip']}>{displayName}</span>}
            >
                {displayName}
            </Tooltip.Flex>
        </FlexLine>
    )
}

export default WorkItemTitle;